"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Teach.Wu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _style = require("./style.js");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function ($) {
  if (!window.dataForGetClue) {
    return;
  }

  var yuyueMatch = {
    "托福": ["托福培训师", "托福考试"],
    "雅思": ["雅思培训师", "雅思考试"],
    "SAT": ["SAT培训师", "SAT考试"],
    "GRE": ["GRE培训师", "GRE考试"],
    "GMAT": ["GMAT培训师", "GMAT考试"],
    "留学": ["留学申请专家", "留学申请"],
    "activity": ["", ""]
  };

  var reg = {
    phone: /^1\d{10}$/,
    code: /^\d+$/
  };

  // const apiUrl = {
  //   sms: dataForGetClue.smsUrl || '//i.service.zhan.test/api/common/sendSms',
  //   saveClue: dataForGetClue.clueUrl || '//i.service.zhan.test/api/clue/first',
  //   orderJijing: dataForGetClue.orderUrl || '//www.zhan.test/zapi/articles/mobilejijingsubscription.html',
  //   downloadApiUrl: dataForGetClue.downloadApiUrl || '//www.zhan.test/zapi/articles/mobilejijingdownload.html'
  // }
  var apiUrl = {
    sms: dataForGetClue.smsUrl || '//i.service.zhan.com/api/common/sendSmsGet', // '//i.service.zhan.com/api/common/sendSms',
    saveClue: dataForGetClue.clueUrl || '//i.service.zhan.com/api/clue/first',
    orderJijing: dataForGetClue.orderUrl || '//www.zhan.com/zapi/articles/mobilejijingsubscription.html',
    downloadApiUrl: dataForGetClue.downloadApiUrl || '//www.zhan.com/zapi/articles/mobilejijingdownload.html'
  };

  var JijingComponent = function () {
    function JijingComponent(params) {
      _classCallCheck(this, JijingComponent);

      var self = this;

      this.params = params;

      //if(params.jijingPage){
      this.initCreate(this.params);
      //}
    }

    _createClass(JijingComponent, [{
      key: "initCreate",
      value: function initCreate(params) {

        if (params.jijingPage) {
          this.pageType = "jijing";this.pageData = params.jijingPage;
        }

        this.isLogin = params.isLogin;

        this.isGetPhone = params.isGetPhone;

        this.container = document.createElement("div");

        this.container.innerHTML = "";

        this.container.setAttribute("id", "clueContainer");

        this.totalCount = 60;

        this.verifyCodeCount = null;

        this.initState();
      }
    }, {
      key: "initState",
      value: function initState() {
        var self = this;

        this.state = { imgCodeUrl: "//i.service.zhan.com/api/common/getCaptcha" };

        Object.defineProperty(self.state, "startDownload", {
          set: function set(download) {
            if (download) {
              self.timeout(3000).then(function () {
                window.open(self.pageData.downloadUrl);
              });
            }
          }
        });

        Object.defineProperty(self.state, "phone", {
          set: function set(phone) {
            if (self.pageData.action != 'yuyue') return;
            var clear = self.query('.input-clear')[0];
            var getCodeBtn = self.query('.first-actionSms')[0];
            if (phone.length > 0) {
              clear.style.display = "block";
              getCodeBtn.style.opacity = "1";
            } else {
              clear.style.display = "none";
              getCodeBtn.style.opacity = "0.5";
            }
          }
        });

        Object.defineProperty(self.state, "code", {
          set: function set(code) {
            if (self.pageData.action != 'yuyue') return;
            var clear = self.query('.input-clear-forcode')[0];
            if (code.length > 0) {
              clear.style.display = "block";
            } else {
              clear.style.display = "none";
            }
          }
        });

        Object.defineProperty(self.state, "showOverlay", {
          set: function set(showOverlay) {
            var overlay = self.container.querySelectorAll('.overlay')[0];
            if (showOverlay) {
              overlay.style.display = "block";
            } else {
              overlay.style.display = "none";
            }
          }
        });

        Object.defineProperty(self.state, "showLoginedPage", {
          set: function set(showLoginedPage) {
            var first = self.container.querySelectorAll('.jijing-first');
            var unlogin = first[0];
            var logined = first[1];
            if (showLoginedPage) {
              unlogin.style.display = "none";
              logined.style.display = "block";
            } else {
              logined.style.display = "none";
              unlogin.style.display = "block";
            }
          }
        });

        Object.defineProperty(self.state, "countRepeat", {

          set: function set(countRepeat) {
            var countDownWrap = self.container.querySelectorAll('.countDownWrap')[0],
                countDownWrapRepeat = self.container.querySelectorAll('.countDownWrapRepeat')[0];
            if (countRepeat) {
              countDownWrap.style.display = "none";
              countDownWrapRepeat.style.display = "block";
              self.container.querySelectorAll('.backStep')[0].style.display = "block";
            } else {
              countDownWrap.style.display = "block";
              countDownWrapRepeat.style.display = "none";
              self.container.querySelectorAll('.backStep')[0].style.display = "none";
            }
          }
        });

        //首页倒计时

        Object.defineProperty(self.state, "countStart", {

          set: function set(countStart) {
            var countDownWrap = self.container.querySelectorAll('.first-countDownWrap')[0],
                actionSms = self.container.querySelectorAll('.first-actionSms')[0],
                countDownWrapRepeat = self.container.querySelectorAll('.first-countDownWrapRepeat')[0];
            if (countStart) {
              countDownWrap.style.display = "none";
              actionSms.style.display = "none";
              countDownWrapRepeat.style.display = "block";
            } else {
              countDownWrap.style.display = "block";
              countDownWrapRepeat.style.display = "none";
              actionSms.style.display = "none";
            }
          }
        });

        Object.defineProperty(self.state, "showMsg", {
          set: function set(showMsg) {
            var msgoverlay = self.container.querySelectorAll('.msgoverlay')[0];
            if (showMsg) {
              msgoverlay.style.display = "block";
            } else {
              msgoverlay.style.display = "none";
            }
          }
        });

        Object.defineProperty(self.state, "page", {
          set: function set(showPage) {
            if (showPage == 1) {
              self.pageType == "jijing" ? self.first.style.display = 'block' : self.first.style.display = 'block';

              self.pageType == "jijing" ? self.state.showOverlay = false : self.state.showOverlay = true;

              self.second.style.display = 'none';

              self.countDown.innerHTML = "60";
              self.totalCount = 60;
              self.container.querySelectorAll('.backStep')[0].style.display = "none";
            } else {
              self.first.style.display = 'none';
              self.second.style.display = 'block';
              self.state.showOverlay = true;
            }
          }
        });

        Object.defineProperty(self.state, "showUI", {
          set: function set(showUI) {
            if (showUI) {
              self.container.style.display = "block";
            } else {
              self.container.style.display = "none";
            }
          }
        });
      }
    }, {
      key: "handleDownload",
      value: function handleDownload() {
        //alert(222);
        //return false;
        var self = this;
        var first = self.container.querySelectorAll('.page-first')[0],
            second = self.container.querySelectorAll('.page-second')[0],
            phone = self.container.querySelectorAll('.clue-input-phone')[0].value,
            countDown = self.container.querySelectorAll('.countDown')[0];

        var msg = "";

        if (!reg.phone.test(phone)) msg = "请输入有效的手机号码";

        if (self.pageData.action == "test") {
          if (self.clueInputName.value.length == 0 || !self.clueInputName) msg = "请输入您的用户名";
        }

        if (msg) {
          self.showMsg(msg);
          return;
        }

        self.phone = phone;

        self.state.countRepeat = false;

        self.actionSms.removeEventListener('click', function () {
          self.handleDownload();
        }, false);

        self.sendVerifyCode();
      }
    }, {
      key: "handleSendMsg",
      value: function handleSendMsg() {

        var self = this;
        if (self.firstActionSms.style["opacity"] != 1) return;
        var phone = self.container.querySelectorAll('.clue-input-phone')[0].value;

        var msg = "";

        if (!reg.phone.test(phone)) msg = "请输入有效的手机号码";

        if (msg) {
          self.showMsg(msg);
          return;
        }

        self.phone = phone;

        self.firstActionSms.removeEventListener('click', function () {
          self.handleSendMsg();
        }, false);

        //如果在倒计时中
        if (self.totalCount != 60) {
          self.showMsg("操作太频繁,请" + self.totalCount + "s后再试");
          return;
        }

        this.firstClueInputCode.value = "";

        this.ajaxSendMsg(self.query('.first-countDown')[0], "countStart", function (state) {
          if (state == 1) {
            self.state.countStart = false;
          }
        });
      }
    }, {
      key: "handleFirstRegetSms",
      value: function handleFirstRegetSms() {
        var self = this;
        var phone = self.query('.clue-input-phone')[0].value;
        self.phone = phone;
        if (!reg.phone.test(self.phone)) {
          self.showMsg('请输入有效的手机号码');
          return;
        }

        this.firstClueInputCode.value = "";
        this.ajaxSendMsg(self.query('.first-countDown')[0], "countStart", function (state) {
          if (state == 1) {
            self.state.countStart = false;
          }
        });
      }
    }, {
      key: "handleRegetSms",
      value: function handleRegetSms() {
        var self = this;

        if (!reg.phone.test(self.phone)) {
          self.showMsg('请输入有效的手机号码');
          return;
        }

        self.state.countRepeat = false;

        self.sendVerifyCode("true");
      }
    }, {
      key: "handleFirstSubmitAction",
      value: function handleFirstSubmitAction() {
        var self = this;
        if (this.actionFirstSubmit.style.opacity != 1) return;
        self.actionFirstSubmit.style.opacity = "0.5";
        var verifyCode = this.firstClueInputCode.value;
        var phone = self.query('.clue-input-phone')[0].value;
        var msg = "";
        if (!reg.code.test(verifyCode)) {
          msg = "请输入有效的验证码";
        }
        if (!reg.phone.test(phone)) {
          msg = "请输入有效的手机号码";
        }
        if (msg) {
          self.showMsg(msg);
          self.actionFirstSubmit.style.opacity = "1";
          return;
        }
        self.phone = phone;
        var params = {
          phone: self.phone,
          phone_code: verifyCode,
          source: '机经',
          type: 2,
          clue_str: self.clue_str
        };

        $.ajax({
          url: apiUrl.saveClue,
          type: 'GET',
          dataType: 'jsonp',
          jsonp: 'callback',
          jsonpCallback: "apicallback",
          data: params,
          success: function success(data) {
            if (data.status == 1) {

              self.showMsg("预约成功");
              self.timeout(2000).then(function () {
                self.state.showUI = false;
                self.handleClueMsgBoxClose();
              });
              self.succseeFinal();
            } else {
              self.showMsg('操作失败\n' + data.message);
            }
            self.actionFirstSubmit.style.opacity = "1";
          },
          error: function error() {
            self.showMsg('服务异常，请稍后再试');
            self.actionFirstSubmit.style.opacity = "1";
          }
        });
      }
    }, {
      key: "handleSubmitAction",
      value: function handleSubmitAction() {
        var self = this;

        if (self.isClick == true) return;
        self.isClick = true;
        self.submitAction.style.backgroundColor = "rgba(255, 102, 0, 0.6)";
        var verifyCode = this.clueInputCode.value;

        if (!reg.code.test(verifyCode)) {
          self.showMsg('请输入有效的验证码');
          self.submitAction.style.backgroundColor = "#ff6600";
          self.isClick = false;
          return;
        }

        var params = {
          phone: self.phone,
          phone_code: verifyCode,
          source: '机经',
          type: 2,
          clue_str: self.clue_str
        };

        var startDownload = false;

        var handleSuccess = function handleSuccess() {

          // 1：机经下载  
          if (self.pageData.action == 'download') {
            //关闭浮层
            self.downloadJijing();
            self.state.page = 1;
            self.state.showLoginedPage = true;
          } else if (self.pageData.action == 'order') {
            // 2: 机经订阅
            // 订阅具体机经文章，调用订阅接口
            var handleInnerSuccess = function handleInnerSuccess() {
              // 订阅成功, 更新订阅数
              // 记录已订阅状态
              var itemKey = 'orderedArticle' + self.pageData.articleId;
              //window.localStorage.setItem(itemKey, 'true');
              $.cookie(itemKey, 'true', { expires: 1, path: '/' });
              self.showMsg('订阅成功');
              self.addCount(".ordercount");
              self.timeout(2000).then(function () {
                self.state.showUI = false;
              });
            };

            var ajaxOrder = $.ajax({
              url: apiUrl.orderJijing,
              type: 'post',
              cache: false,
              dataType: 'json',
              asyns: false,
              data: {
                "articleId": self.pageData.articleId
              },
              success: function success(data) {
                if (data.status == "success") {
                  handleInnerSuccess();
                } else {
                  self.showMsg('订阅失败，请稍后再试');
                }
                self.isClick = false;
                self.submitAction.style.backgroundColor = "#ff6600";
              },
              error: function error(data) {
                self.showMsg('订阅服务异常，请稍后再试');
                self.isClick = false;
                self.submitAction.style.backgroundColor = "#ff6600";
              }
            });
          } else if (self.pageData.action == 'yuyue' || self.pageData.action == 'test' || self.pageData.action == 'contact') {
            //3:预约&测试
            self.showMsg(self.pageData.action == 'yuyue' || self.pageData.action == 'contact' ? "预约成功" : "申请成功");
            self.isClick = false;
            self.timeout(2000).then(function () {
              self.state.page = 1;
              self.state.showUI = false;
              self.handleClueMsgBoxClose();
            });
          } else if (self.pageData.action == 'appDownload') {

            //3:app下载
            self.isClick = false;
            setTimeout(function () {
              self.state.page = 1;
              self.state.showUI = false;
              self.handleClueMsgBoxClose();
              window.location.href = self.pageData.url;
            }, 500);
          }

          self.succseeFinal();
        };

        $.ajax({
          url: apiUrl.saveClue,
          type: 'GET',
          dataType: 'jsonp',
          jsonp: 'callback',
          jsonpCallback: "apicallback",
          data: params,
          success: function success(data) {
            if (data.status == 1) {
              if (self.pageData.action == 'download') {
                startDownload = true;
              } else {
                clearInterval(self.checkLoad);
              };
              handleSuccess();
            } else {
              self.showMsg('操作失败\n' + data.message);
            }
            self.isClick = false;
            self.submitAction.style.backgroundColor = "#ff6600";
          },
          error: function error() {
            self.showMsg('服务异常，请稍后再试');
            self.isClick = false;
            self.submitAction.style.backgroundColor = "#ff6600";
          }
        });

        self.checkLoad = setInterval(function () {
          if (startDownload) {
            window.location.href = self.pageData.downloadUrl;
            clearInterval(self.checkLoad);
          }
        }, 1000);
      }
    }, {
      key: "succseeFinal",
      value: function succseeFinal() {
        var signStatus = self.isLogin ? 'Signed On' : 'Signed Off';
        //window.localStorage.setItem("isGetPhone",'true');
        $.cookie('isGetPhone', 'true', { expires: 1, path: '/' });
        window.ga('send', 'event', 'xkzhongduan', window.location.href, signStatus);
      }
    }, {
      key: "handleSubmitActionForDirect",
      value: function handleSubmitActionForDirect() {
        var self = this;
        if (self.pageData.action == 'download') {
          self.downloadJijing();
          window.open(self.pageData.downloadUrl);
        } else if (self.pageData.action == 'order') {
          // 订阅具体机经文章，调用订阅接口
          self.orderJijing();
        }
      }
    }, {
      key: "orderJijing",
      value: function orderJijing() {
        var self = this;
        var handleInnerSuccess = function handleInnerSuccess() {
          // 订阅成功, 更新订阅数
          // 记录已订阅状态
          var itemKey = 'orderedArticle' + self.pageData.articleId;
          //window.localStorage.setItem(itemKey, 'true');
          $.cookie(itemKey, 'true', { expires: 1, path: '/' });
          self.showMsg('订阅成功');
          self.addCount(".ordercount");
          self.timeout(2000).then(function () {
            self.state.showUI = false;
          });
        };

        var ajaxOrder = $.ajax({
          url: apiUrl.orderJijing,
          type: 'post',
          cache: false,
          dataType: 'json',
          data: {
            "articleId": self.pageData.articleId
          },
          success: function success(data) {
            if (data.status == "success") {
              handleInnerSuccess();
            } else {
              self.showMsg('订阅失败，请稍后再试');
            }
          },
          error: function error(data) {
            self.showMsg('订阅服务异常，请稍后再试');
          }
        });
      }
    }, {
      key: "startVCodeCounter",
      value: function startVCodeCounter(isRepeat) {
        var self = this;

        //如果在倒计时中
        if (self.totalCount != 60) {
          self.showMsg("操作太频繁,请" + self.totalCount + "s后再试");
          return;
        }

        if (isRepeat == "false") self.state.page = 2;
      }
    }, {
      key: "ajaxSendMsg",
      value: function ajaxSendMsg(el, state, callback) {
        var self = this;
        if (self.getImgCode() == "") {
          self.showMsg('请输入图形验证码');
          return false;
        }

        clearInterval(self.verifyCodeCount);

        self.verifyCodeCount = setInterval(function () {
          var time = self.totalCount - 1;
          self.totalCount = time;
          el.innerHTML = time;
          if (time == 0) {
            self.clearVerifyCodeCount(el, state);
          }
        }, 1000);
        $.ajax({
          url: apiUrl.sms,
          type: 'get',
          cache: false,
          dataType: 'jsonp',
          jsonp: 'callback',
          data: {
            "phone": self.phone,
            "type": 10,
            "yzm": self.getImgCode()
          },
          success: function success(data) {
            if (data.status != 1) {
              self.showMsg(data.message);
              self.clearVerifyCodeCount(el, state);
            }
            //self.reGetImg();
            if (callback !== undefined) {
              callback(data.status);
            }
          },
          error: function error(data) {
            self.showMsg('发送验证码服务异常，请稍后再试');
          }
        });
      }
    }, {
      key: "clearVerifyCodeCount",
      value: function clearVerifyCodeCount(el, state) {
        var self = this;
        el.innerHTML = "60";
        self.totalCount = 60;
        this.state[state] = true;
        clearInterval(self.verifyCodeCount);
      }

      // 发送验证码

    }, {
      key: "sendVerifyCode",
      value: function sendVerifyCode() {
        var isRepeat = arguments.length <= 0 || arguments[0] === undefined ? "false" : arguments[0];


        var self = this;
        this.clueInputCode.value = "";

        this.ajaxSendMsg(self.countDown, "countRepeat", function (state) {
          if (state == 1) {
            self.startVCodeCounter(isRepeat);
          }
        });
      }
    }, {
      key: "openWindow",
      value: function openWindow(owurl) {
        var astr = "<a href='" + owurl + "' target='_blank'></a>";
        if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.match(/8./i) == "8.") {
          window.open(owurl);
        } else {
          var a = $(astr).get(0);
          var e = document.createEvent('MouseEvents');
          e.initEvent('click', true, true);
          a.dispatchEvent(e);
        }
      }
    }, {
      key: "handleHideUI",
      value: function handleHideUI() {
        if (this.pageData.action == "order" || this.pageData.action == "download") {
          this.handleBackStep();
          return;
        }
        var self = this;
        self.state.showUI = false;
        self.handleClueMsgBoxClose();
      }
    }, {
      key: "handleBackStep",
      value: function handleBackStep() {
        this.state.page = 1;
      }
    }, {
      key: "showMsg",
      value: function showMsg(msg) {
        this.clueMsgBoxContent.innerHTML = msg;
        this.state.showMsg = true;
      }
    }, {
      key: "handleClueMsgBoxClose",
      value: function handleClueMsgBoxClose() {
        this.state.showMsg = false;
      }
    }, {
      key: "timeout",
      value: function timeout(ms) {
        return new Promise(function (resolve) {
          setTimeout(resolve, ms, "done");
        });
      }
    }, {
      key: "addCount",
      value: function addCount(classNmae) {
        var count = parseInt($(classNmae).text()) + 1;
        $(classNmae).text(count);
        this.clueCountF.innerHTML = this.clueCountS.innerHTML = count;
      }

      // 机经下载

    }, {
      key: "downloadJijing",
      value: function downloadJijing() {
        var self = this;
        $.post(apiUrl.downloadApiUrl, {
          downloadId: self.pageData.downloadId
        }).done(function (data) {
          if (data.status != "success") {
            self.showMsg('下载失败，请稍后再试');
          } else {
            self.addCount(".downloadcount");
          }
        }).fail(function () {
          self.showMsg('服务异常，请稍后再试');
        });
      }
    }, {
      key: "handleSelectFocus",
      value: function handleSelectFocus(e) {
        if (e.target && e.target.nodeName != "SPAN") return;
        var clueFocus = this.query('.clue-focus')[0];
        var cArray = clueFocus.children;

        for (var i = 0; i < cArray.length; i++) {
          cArray[i].className = "";
        }

        e.target.className = "hotFocus";
      }
    }, {
      key: "initPage",
      value: function initPage() {
        this.state.page = 1;

        this.clue_str = "";

        if (this.pageData.action == 'order') this.clue_str = window.jijingSubscriptionSource || "";

        if (this.pageData.action == 'download') this.clue_str = window.jijingDownloadSource || "";

        if (this.pageData.action == 'yuyue') this.clue_str = window.consultationSource || "";

        if (this.pageData.action == 'contact') this.clue_str = window.contactSource || "";

        if (this.pageData.action == 'test') this.clue_str = window.testingSource || "";

        if (this.pageData.clue_str) this.clue_str = this.pageData.clue_str;

        var isGetPhoneLocal = $.cookie("isGetPhone");

        if (this.pageType == "jijing") {
          if (this.pageData.action == "download") {
            if (this.isLogin && this.isGetPhone == true || isGetPhoneLocal == "true") {
              this.state.showLoginedPage = true;
            } else {
              this.state.showLoginedPage = false;
            }

            this.clueCountF.innerHTML = this.clueCountS.innerHTML = $(".downloadcount").text();
          } else {
            if (this.isLogin && this.isGetPhone == true && isGetPhoneLocal == "true") {
              this.state.showLoginedPage = true;
            } else {
              this.state.showLoginedPage = false;
            }

            this.clueCountF.innerHTML = this.clueCountS.innerHTML = $(".ordercount").text();
          }
        } else {
          //预约界面，初始隐藏
          this.state.showUI = false;
        }
      }
    }, {
      key: "query",
      value: function query(select) {
        return this.container.querySelectorAll(select);
      }
    }, {
      key: "bindClick",
      value: function bindClick(el, callback) {
        var _this = this;

        var self = this;
        el ? el.addEventListener('click', function () {
          callback.apply(_this);
        }, false) : null;
      }
    }, {
      key: "unbindClick",
      value: function unbindClick(el, callback) {
        var _this2 = this;

        var self = this;
        el ? el.removeEventListener('click', function () {
          callback.apply(_this2);
        }, false) : null;
      }
    }, {
      key: "reGetImg",
      value: function reGetImg() {
        this.imgCodeEl = this.query('.imgCode')[0];
        $(this.imgCodeEl).attr("src", this.state.imgCodeUrl + "?" + Math.random());
      }
    }, {
      key: "getImgCode",
      value: function getImgCode() {
        return this.imgCodeInputEl.value;
      }
    }, {
      key: "initEvent",
      value: function initEvent() {
        var self = this;

        var countDownWrapRepeat = this.query('.countDownWrapRepeat')[0],
            clueMsgBoxClose = this.query('.clue-msg-box-close')[0],
            msgoverlay = this.query('.msgoverlay')[0],
            clueFocus = this.query('.clue-focus')[0],
            backStep = this.query('.backStep')[0];

        this.firstCountDownWrapRepeat = this.query('.first-countDownWrapRepeat')[0];

        this.submitAction = this.query('.submitAction')[0];

        this.actionFirstSubmit = this.query('.actionFirstSubmit')[0];

        this.submitActionForDirect = this.query('.submitActionForDirect')[0];

        this.clueMsgBoxContent = this.query('.clue-msg-box-content')[0];

        this.clueCountF = this.query('.clue-count')[0];
        this.clueCountS = this.query('.clue-count')[1];

        this.clueInputCode = this.query('.clue-input-code')[0];
        this.firstClueInputCode = this.query('.first-input-code')[0];
        this.clueInputName = this.query('.clue-input-name')[0];

        this.clueOverlay = this.query('.clue-overlay')[0];

        this.actionSms = this.query('.actionSms')[0];

        this.firstActionSms = this.query('.first-actionSms')[0];

        this.first = self.container.querySelectorAll('.page-first')[0];

        this.second = self.container.querySelectorAll('.page-second')[0];

        this.countDown = self.container.querySelectorAll('.countDown')[0];

        this.cancelBtn = this.query('.cancel-btn')[0];

        this.imgCodeEl = this.query('.imgCode')[0];
        this.imgCodeInputEl = this.query('.imgCodeInput')[0];
        this.clueOverlay ? this.clueOverlay.addEventListener('click', function () {
          self.handleHideUI();
        }, false) : null;

        this.bindClick(this.cancelBtn, self.handleHideUI);

        this.bindClick(this.actionSms, self.handleDownload);

        this.bindClick(this.firstActionSms, self.handleSendMsg);

        this.bindClick(this.firstCountDownWrapRepeat, self.handleFirstRegetSms);

        countDownWrapRepeat ? countDownWrapRepeat.addEventListener('click', function () {
          self.handleRegetSms();
        }, false) : null;

        this.submitAction ? this.submitAction.addEventListener('click', function () {
          self.handleSubmitAction();
        }, false) : null;

        this.bindClick(this.actionFirstSubmit, self.handleFirstSubmitAction);

        this.submitActionForDirect ? this.submitActionForDirect.addEventListener('click', function () {
          self.handleSubmitActionForDirect();
        }, false) : null;

        this.bindClick(this.imgCodeEl, self.reGetImg);

        msgoverlay ? msgoverlay.addEventListener('click', function (e) {
          e.target.nodeName == "DIV" ? self.handleClueMsgBoxClose() : null;
        }, false) : null;

        clueMsgBoxClose ? clueMsgBoxClose.addEventListener('click', function () {
          self.handleClueMsgBoxClose();
        }, false) : null;

        clueFocus ? clueFocus.addEventListener('click', function (e) {
          self.handleSelectFocus(e);
        }, false) : null;

        backStep ? backStep.addEventListener('click', function () {
          self.handleBackStep();
        }, false) : null;

        //点击链接订阅框focus，弹出手机键盘
        $(".getClueByOrderForClick").click(function () {
          $(".clue-input-phone").focus();
        });

        $(".first-clue-input-phone").bind("keyup", function () {
          self.state.phone = $(this).val();
          self.actionFirstSubmit.style.opacity = $(this).val() > 0 && $(".first-input-code").val().length > 0 ? "1" : "0.5";
        });

        $(".first-input-code").bind("keyup", function () {
          self.state.code = $(this).val();
          self.actionFirstSubmit.style.opacity = $(this).val() > 0 && $(".clue-input-phone").val().length > 0 ? "1" : "0.5";
        });

        $(".input-clear-forphone").click(function () {
          $(this).parent().find("input").val("");
          self.state.phone = "";
          $(".input-clear-forphone").hide();
        });

        $(".input-clear-forcode").click(function () {
          $(this).parent().find("input").val("");
          self.state.code = "";
          $(".input-clear-forcode").hide();
        });

        $(function () {
          $(".foot").css("padding-bottom", "40px");
        });
      }
    }, {
      key: "render",
      value: function render() {

        var self = this;

        function getFocus() {
          var focus = "";
          self.pageData.focus.map(function (c) {
            focus += "<span>" + c + "</span>";
          });
          return focus;
        }

        var finishBtnText = "完成订阅";

        if (this.pageData.action == "test") finishBtnText = "完成测试预约";
        if (this.pageData.action == "download") finishBtnText = "完成下载";
        if (this.pageData.action == "yuyue" || this.pageData.action == "contact") finishBtnText = "完成预约";

        this.pageData.finishBtnTitle ? finishBtnText = this.pageData.finishBtnTitle : null;

        var yuyuehead, yuyuetitle, yuyuebtn;

        var first = self.pageType == "jijing" ? "<div class=\"jijing-first page-first\">\n                    <div>\n                        <section class='jijing-input-wrap'>\n                          <input class='clue-input clue-input-phone' placeholder='填写您的手机号' type=\"tel\"/>\n                        </section>\n\n                        <section class='jijing-info-wrap'>\n                          <span class='clue-count'>0</span>\n                          <span>" + (this.pageData.action == "download" ? "次已下载" : "人已订阅") + "</span>\n                        </section>\n\n                        <section>                        \n                          <button class='clue-btn actionSms'>\n                            <span class=" + (this.pageData.action == "download" ? "icon-xuanfu_xiazai" : "") + "></span>\n                            立即" + (this.pageData.action == "download" ? "下载" : "订阅") + "</button>\n                        </section>\n                    </div>\n                    <div>\n                     <section style=\"padding-top:0px;width:100%; margin-left:10px\">\n                        <input class=\"clue-input  imgCodeInput\" style=\"margin-top:0px;width:45%\" placeholder='请输入图形验证码' />\n                        <span class=\"input-clear input-clear-forcode\"></span> \n                       \n                        <a style=\"vertical-align:middle; display:inline-block\"><img style=\"width:55%\" class=\"imgCode\"  src=\"//i.service.zhan.com/api/common/getCaptcha\"></a>\n                      \n                      </section>\n                    </div>\n</div>\n\n\n                    <div class=\"jijing-first\">\n                        <section class='jijing-logined-wrap'>\n                          本期机经快速" + (this.pageData.action == "download" ? "下载" : "订阅") + "通道\n                        </section>\n                        <section class='jijing-info-wrap'>\n                          <span class='clue-count'>0</span>\n                          <span>" + (this.pageData.action == "download" ? "次已下载" : "人已订阅") + "</span>\n                        </section>\n                        <section>\n                          \n                          <button class='clue-btn submitActionForDirect'><span class=" + (this.pageData.action == "download" ? "icon-xuanfu_xiazai" : "") + "></span>立即" + (this.pageData.action == "download" ? "下载" : "订阅") + "</button>\n                        </section>\n                    </div>\n                  " : (yuyuehead = this.pageData.action == "yuyue" ? "我对" + yuyueMatch[this.pageData.type][1] + "有疑问，请老师尽快回电！" : "为确保录取几率的客观真实，小站留学顾问将联系您进行一对一定制分析。", yuyuehead = this.pageData.action == "contact" ? "请留下您的联系方式，小站老师将会尽快与您取得联系" : yuyuehead,
        //直接取headIntroText
        this.pageData.headIntroText ? yuyuehead = this.pageData.headIntroText : null, yuyuetitle = this.pageData.action == "yuyue" ? "预约" + yuyueMatch[this.pageData.type][0] + "答疑解惑" : "测试录取几率",
        //活动弹窗
        yuyuetitle = this.pageData.action == "contact" ? "联系老师" : yuyuetitle,
        //直接取title中的值
        this.pageData.title ? yuyuetitle = this.pageData.title : null, yuyuebtn = this.pageData.action == "yuyue" || this.pageData.action == "contact" ? "立即预约" : "申请测试",
        //直接取btnTitle中的值
        this.pageData.btnTitle ? yuyuebtn = this.pageData.btnTitle : null, "<div class=\"yuyue-first page-first\">\n                    <header class='yuyue-first-title'>\n                      <span>" + yuyuetitle + "</span><span class=\"cancel-btn\">取消</span></header>\n                    <section class='yuyue-first-inner-wrap'>\n                      <header>" + yuyuehead + "</header>\n\n                      <section style=" + (this.pageData.action == "yuyue" || this.pageData.action == "contact" || this.pageData.action == "appDownload" ? "display:none" : "display:block;") + ">\n                        <input class='clue-input clue-input-name' placeholder='请输入您的姓名' type=\"text\"/>\n                      </section>\n\n                      <section style=" + (this.pageData.action == "yuyue" ? "" : "display:block;") + ">\n                        <input class='clue-input first-clue-input-phone clue-input-phone' placeholder='请输入您的联系电话' type=\"tel\"/>\n                        <span class=\"input-clear input-clear-forphone\"></span>\n                      </section>\n\n\n                      <section >\n                        <input class=\"clue-input  imgCodeInput\" style=\"margin-top:0px;width:45%\" placeholder='请输入图形验证码' />\n                        <span class=\"input-clear input-clear-forcode\"></span> \n                       \n                          <a style=\"display:inline-block;padding-top:5px\"><img class=\"imgCode\" style=\"width:55%\"   src=\"//i.service.zhan.com/api/common/getCaptcha\"></a>\n                       \n                      </section>\n\n                      <section style=" + (this.pageData.action == "yuyue" ? "display:block;" : "display:none;") + ">\n                        <input class=\"clue-input first-input-code\" style=\"width:45%;margin-top:10px\" placeholder='请输入短信验证码' type=\"tel\"/>\n                        <span class=\"input-clear input-clear-forcode\"></span>\n                        <div style=\"padding-top:15px;\">\n                          <section class=\"first-actionSms\">获取验证码</section>\n                          <section class=\"first-countDownWrap\"><span class=\"first-countDown\">60</span>s后重新获取验证码</section>\n                          <section class=\"first-countDownWrapRepeat\">重新获取</section>\n                        </div>\n                      </section>\n\n                    </section>\n                    <footer style=" + (this.pageData.action == "yuyue" ? "display:none" : "display:block") + ">\n                      <header style=" + (this.pageData.action == "contact" ? "display:block" : "display:none") + ">关注热点:</header>\n                      <section class=\"clue-focus\" style=" + (this.pageData.action == "contact" ? "display:block" : "display:none") + ">\n                        " + (this.pageData.action == "contact" ? getFocus() : '') + "\n                      </section>\n                      <button class='clue-btn actionSms'>" + yuyuebtn + "</button>\n                    </footer>\n                    <footer style=" + (this.pageData.action == "yuyue" ? "display:block" : "display:none") + ">\n                      <button class='clue-btn actionFirstSubmit'>" + yuyuebtn + "</button>\n                    </footer>\n                 </div>\n                ");

        var headIntroText = "小站会员专属特权 订阅机经后第一时间获取更新通知";
        var secondPagehead = this.pageType == "jijing" ? this.pageData.action == "download" ? self.pageData.type + "机经下载" : self.pageData.type + "机经订阅" : this.pageData.action == "yuyue" ? "预约咨询" : "测试录取几率";
        secondPagehead = this.pageData.action == "contact" ? "联系老师" : secondPagehead;

        if (this.pageData.action == "test") headIntroText = "为确保录取几率的客观真实，小站留学顾问将联系您进行一对一定制分析。";

        if (this.pageData.action == "download") headIntroText = "小站会员专属特权 本期机经完整版免费下载。";

        if (this.pageData.action == "yuyue") headIntroText = this.pageData.subject + "有难题？留下您的联系方式，小站" + this.pageData.type + "专家1对1为您解答。";

        if (this.pageData.action == "contact") headIntroText = "请留下您的联系方式，小站老师将会尽快与您取得联系";

        //直接取headIntroText
        this.pageData.title ? secondPagehead = this.pageData.title : null;
        //直接取headIntroText
        this.pageData.headIntroText ? headIntroText = this.pageData.headIntroText : null;

        var jijingUI = _style2["default"] + "\n            <div class=\"overlay clue-overlay\" id=\"clue-overlay\" style=" + (this.pageType == "jijing" ? "display:none" : "display:block") + "></div>\n            <div class=\"msgoverlay\">\n                  <div class=\"clue-msg-box\">\n                    <section class=\"clue-msg-box-content\">请输入正确的11位手机号！</section>\n                    <footer><span class=\"clue-msg-box-close\">确定</span></footer>\n                  </div>\n                </div>\n            <div class='clue-container'>\n              <div class='jijing-container' id=\"jijing-container\">\n\n                " + first + "\n\n                <div class=\"page-second page-second-style\">\n                    <header class='second-title'>\n                      <span>" + secondPagehead + "</span><span class=\"backStep\">返回上一步</span></header>\n                    <section class='second-inner-wrap'>\n                      <header>\n                      " + headIntroText + "</header>\n                      <section>\n                        <input id=\"tsphone\" class='clue-input clue-input-code' placeholder='请输入短信验证码' type=\"tel\"/>\n                        <div>\n                          <section class=\"countDownWrap\"><span class=\"countDown\">60</span>s后重新获取验证码</section>\n                          <section class=\"countDownWrapRepeat\">重新获取</section>\n                        </div>\n                      </section>\n                    </section>\n                    <footer>\n                      <button class='clue-btn submitAction'><span class=\"icon-btn_ok\"></span>\n                        " + finishBtnText + "\n                      </button>\n                    </footer>\n                </div>\n              </div>\n            </div>\n          ";
        this.container.innerHTML = "";
        this.container.innerHTML = jijingUI;

        if (self.pageData) {
          var action = self.pageData.action;
          var itemKey = 'orderedArticle' + self.pageData.articleId;

          //联系我,预约,下载,未订阅过该机经的显示
          if (action == 'test' || action == 'appDownload' || action == 'yuyue' || action == 'download' || action == 'contact' || action == 'order' && $.cookie(itemKey) != "true") {
            document.body.appendChild(this.container);
          }
        }

        this.initEvent();

        this.initPage();
      }
    }]);

    return JijingComponent;
  }();

  var getClue = new JijingComponent(dataForGetClue);

  if (window.dataForGetClue.jijingPage) getClue.render();

  $('.getClueByYuyue').click(function () {
    getClue.pageType = "yuyue";
    getClue.pageData = getClue.params.yuyuePage.yuyue;

    getClue.render();
    getClue.state.showUI = true;
  });

  $('.getClueByActivity').click(function () {
    // var clearBodyScroll;
    // if(clearBodyScroll){
    //   clearInterval(clearBodyScroll);
    // }
    getClue.pageType = "yuyue";
    getClue.pageData = getClue.params.yuyuePage.activity;

    getClue.render();
    getClue.state.showUI = true;

    //fix ios fixed layout bug
    // var bodyClass=document.body.className;

    // document.body.className="bodyNOScroll "+bodyClass;
    // document.body.style.height=window.innerHeight+"px";
    // var clueContainer=document.getElementById("clueContainer");
    // clearBodyScroll=setInterval(function(){
    //   if(clueContainer.style.display=="none"){
    //     clearInterval(clearBodyScroll);

    //     var bodyClass=document.body.className;
    //     bodyClass=bodyClass.replace(/bodyNOScroll /g, "");

    //     document.body.className=bodyClass;
    //     document.body.style.height="auto";
    //   }
    // },500);
  });

  $('.getClueByContact').click(function () {
    getClue.pageType = "contact";
    getClue.pageData = getClue.params.contactPage.contact;

    getClue.render();
    getClue.state.showUI = true;
  });

  //论坛app下载
  $('.getClueByAppDownload').click(function () {
    var key = $(this).attr("key");
    var initdata = getClue.params[key].initdata;
    getClue.pageType = initdata.action;
    getClue.pageData = initdata;
    //用户已登录
    if (window.dataForGetClue.isLogin || window.dataForGetClue.isGetPhone || $.cookie("isGetPhone") == "true") {
      window.location.href = initdata.url;
    } else {
      getClue.render();
      getClue.state.showUI = true;
    }
  });

  $('.getClueByTest').click(function () {

    getClue.pageType = "yuyue";
    getClue.pageData = getClue.params.yuyuePage.test;
    getClue.render();
    getClue.state.showUI = true;
  });
})(jQuery);


/*****************
 ** WEBPACK FOOTER
 ** ./src/getClue.js
 ** module id = 1
 ** module chunks = 0
 **/